import {
    CampaignEntity,
    OrganizationEntitiesIds,
    OrganizationEntity,
    OrganizationsState
} from "../store/organizations/types";
import {union} from "lodash";

export interface IdObject {
    id: string;
}

export interface IdObjectsWithId<T extends IdObject> {
    byId: {
        [key: string]: T
    },
}

const arrayToObject = <T extends IdObject>(array: Array<T>): IdObjectsWithId<T> => {
    return array.reduce((result: IdObjectsWithId<T>, item: T) => {
        result.byId[item.id] = item;
        return result
    }, {
        byId: {},
    });
}

export interface ILoadNewEntitiesForOrganizationArgs<T extends IdObject> extends ILoadNewEntities<T> {
    organizationId: string;
    entityIdsKey: keyof OrganizationEntitiesIds;
}

const loadNewEntitiesForOrganization = <T extends IdObject>(args: ILoadNewEntitiesForOrganizationArgs<T>) => {
    if (!args.state.organizations.byId || !args.state.organizations.byId[args.organizationId]) {
        console.log(args)
        return args.state
    }
    const newEntitiesObject = arrayToObject(args.newEntities);
    return {
        ...args.state,
        organizations: {
            ...args.state.organizations,
            byId: {
                ...args.state.organizations.byId,
                [args.organizationId]: {
                    ...args.state.organizations.byId[args.organizationId],
                    [args.entityIdsKey]: union(
                        args.state.organizations.byId[args.organizationId][args.entityIdsKey],
                        Object.keys(newEntitiesObject.byId)
                    )
                }
            }
        },
        ..._loadNewEntities(args, newEntitiesObject)
    }
}

export interface ILoadNewEntities<T extends IdObject> {
    state: OrganizationsState;
    newEntities: IdObject[];
    entitiesKey: keyof CampaignEntity | keyof OrganizationEntity;
}


const loadNewEntities = <T extends IdObject>(args: ILoadNewEntities<T>) => {
    const newEntitiesObject = arrayToObject(args.newEntities);
    return {
        ...args.state,
        ..._loadNewEntities(args, newEntitiesObject)
    }
}

const _loadNewEntities = <T extends IdObject>(args: ILoadNewEntities<T>, newEntitiesObject: IdObjectsWithId<T>) => {
    return {
        [args.entitiesKey]: {
            ...args.state[args.entitiesKey],
            byId: {
                ...args.state[args.entitiesKey].byId,
                ...newEntitiesObject.byId,
            },
        }
    }
}

export type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U]


export {arrayToObject, loadNewEntitiesForOrganization, loadNewEntities};
